import React from 'react';
import colors from '../../../styles/colors/index.module.scss';

interface Props {
  width?: number | string;
  color?: string;
  className?: string;
}

export const CurvyArrowThree: React.FC<Props> = ({
  width = 100,
  color = colors.primary,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 112.45 105.4"
    width={width}
    height={typeof width === 'number' ? width * (105.4 / 112.45) : 'auto'}
    className={className}
  >
    <path
      fill={colors.secondary}
      d="M24.89,102.9c0-.67-6.87-30.59-6.87-30.59l-15.52,19.07,22.39,11.53Z"
    />
    <path
      fill={color}
      className="cls-2"
      d="M111.13,36.1c-1.22-.72-3.09-.34-3.76.99-3.31,6.52-10.3,10.03-17.35,10.84-6.2.71-12.6-.07-18.75-1.55,1.49-9.87.09-20.25-3.8-29.36C64.12,9.19,58.09,1.68,49.21.25c-4.15-.67-8.54-.03-12,2.5-2.95,2.15-4.97,5.12-6.21,8.54-2.61,7.23-.79,15.14,3.78,21.14,5.3,6.94,13.12,11.34,21.03,14.67,2.93,1.23,5.95,2.31,9.02,3.24-.75,2.76-1.75,5.43-3.04,7.96-7.01,13.67-21.3,20.07-35.13,24.83-1.12.38-2.24.75-3.36,1.13-.79-3.47-1.73-7.6-2.86-12.51-.21-.93-.94-1.66-1.87-1.88-.93-.22-1.9.12-2.5.86L.56,89.79c-.48.58-.66,1.35-.51,2.09.15.74.63,1.37,1.3,1.71l22.39,11.53c.36.19.75.28,1.14.28.45,0,.9-.12,1.3-.37.74-.45,1.2-1.26,1.2-2.13,0-.26,0-.67-2.85-13.25,15.25-5.09,31.31-11.27,40.25-25.48,2.43-3.86,4.18-8.05,5.35-12.41,4.54,1.05,9.16,1.72,13.77,1.88,8.93.31,18.44-2.01,24.7-8.77,1.38-1.5,2.58-3.17,3.51-4.99.67-1.32.35-2.98-.99-3.76ZM6.39,90.56l10.34-12.71c1.64,7.18,3.49,15.32,4.63,20.41l-14.97-7.71ZM64.11,44.34c-7.34-2.4-14.94-5.73-20.81-10.86-2.65-2.31-4.9-4.98-6.44-8.15-1.36-2.8-1.73-5.47-1.48-8.51.44-5.3,3.83-10.76,9.62-11.32,7.67-.73,13.38,5.44,16.53,11.71,4.19,8.34,5.75,18.29,4.42,27.71-.62-.19-1.23-.38-1.84-.58Z"
    />
  </svg>
);
